import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container mt-4" }
const _hoisted_2 = { class: "row d-flex align-items-center mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "Pension Payments", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Check #"),
    /*#__PURE__*/_createElementVNode("th", null, "Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Run Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Reversal"),
    /*#__PURE__*/_createElementVNode("th", null, "Gross Amount"),
    /*#__PURE__*/_createElementVNode("th", null, "Deductions"),
    /*#__PURE__*/_createElementVNode("th", null, "Net Amount"),
    /*#__PURE__*/_createElementVNode("th", null, "Status")
  ])
], -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h5", null, "Totals", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("table", null, [
        _hoisted_4,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.payments, (payment, id) => {
            return (_openBlock(), _createElementBlock("tr", { key: id }, [
              _createElementVNode("td", null, _toDisplayString(payment.CheckNumber), 1),
              _createElementVNode("td", null, _toDisplayString(payment.CheckDate), 1),
              _createElementVNode("td", null, _toDisplayString(payment.RunType), 1),
              _createElementVNode("td", null, _toDisplayString(payment.TransactionType === 'R' ? 'Yes' : 'No'), 1),
              _createElementVNode("td", null, _toDisplayString(payment.Amount.Gross), 1),
              _createElementVNode("td", null, [
                (payment.Deductions.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formatDeductions(payment.Deductions), (deduction, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          innerHTML: deduction
                        }, null, 8, _hoisted_6))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(payment.Amount.Deductions), 1))
              ]),
              _createElementVNode("td", null, _toDisplayString(payment.Amount.Net), 1),
              _createElementVNode("td", null, _toDisplayString(payment.ClearDate === null ? 'Not Cleared' : 'Cleared'), 1)
            ]))
          }), 128))
        ])
      ]),
      _hoisted_8,
      _hoisted_9,
      _createElementVNode("table", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, _toDisplayString($setup.totals.Gross), 1),
          _createElementVNode("td", null, _toDisplayString($setup.totals.Deductions), 1),
          _createElementVNode("td", null, _toDisplayString($setup.totals.Net), 1)
        ])
      ])
    ])
  ]))
}